(() => {
  const initialiseProduct = (root = document) => {
    root.querySelectorAll('[data-product-root]:not([data-product-ready])').forEach((productRoot) => {
      productRoot.dataset.productReady = 'true';
      const variantsNode = productRoot.querySelector('[data-product-variants]');
      const form = productRoot.querySelector('[data-product-form]');
      const variantInput = productRoot.querySelector('[data-variant-id]');
      const price = productRoot.querySelector('[data-product-price]');
      const availability = productRoot.querySelector('[data-product-availability]');
      const button = productRoot.querySelector('[data-add-button]');
      const label = productRoot.querySelector('[data-add-label]');
      const priceRequest = productRoot.dataset.priceRequest === 'true';
      const isConsignment = productRoot.dataset.consignment === 'true';
      const isSingleVariant = productRoot.dataset.singleVariant === 'true';
      const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
      const strings = {
        add: button?.dataset.labelAdd || 'Add to bag',
        soldOut: button?.dataset.labelSoldOut || 'Sold out',
        unavailable: button?.dataset.labelUnavailable || 'Unavailable',
        available: availability?.dataset.labelAvailable || 'Available',
        sold: availability?.dataset.labelSold || 'Sold',
        enquire: availability?.dataset.labelEnquire || 'Enquire to confirm'
      };

      const updateVariant = () => {
        const choices = [...productRoot.querySelectorAll('[data-option-position]:checked')]
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((input) => input.value);
        const variant = variants.find((item) => item.options.every((option, index) => option === choices[index]));
        if (!variant) {
          if (button) button.disabled = true;
          if (label) label.textContent = strings.unavailable;
          if (availability) availability.textContent = strings.unavailable;
          return;
        }
        if (variantInput) variantInput.value = variant.id;
        if (price && !priceRequest) {
          // An unpriced variant sends null rather than a formatted zero.
          // Hide the line entirely rather than writing $0.00 into the page.
          if (variant.price == null) {
            price.innerHTML = '';
            price.hidden = true;
          } else {
            price.hidden = false;
            price.innerHTML = variant.comparePrice ? `<s>${variant.comparePrice}</s> ${variant.price}` : variant.price;
          }
        }
        const canSell = isConsignment
          ? isSingleVariant
            && variant.available
            && variant.inventoryManagement === 'shopify'
            && variant.inventoryPolicy === 'deny'
            && variant.inventoryQuantity > 0
          : variant.available;
        const isSold = !variant.available
          || (variant.inventoryManagement === 'shopify' && variant.inventoryQuantity <= 0);
        if (button) button.disabled = !canSell;
        if (label) label.textContent = canSell ? strings.add : (isConsignment && isSold ? strings.sold : strings.soldOut);
        if (availability) availability.textContent = canSell
          ? strings.available
          : (isConsignment ? (isSold ? strings.sold : strings.enquire) : strings.soldOut);
        if (variant.url) history.replaceState({}, '', variant.url);
        if (variant.mediaId) {
          const media = productRoot.querySelector(`[data-media-id="${variant.mediaId}"]`);
          media?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        }
      };
      form?.addEventListener('change', updateVariant);

      const gallery = productRoot.querySelector('[data-product-gallery]');
      const media = [...productRoot.querySelectorAll('[data-product-media]')];
      const current = productRoot.querySelector('[data-gallery-current]');
      const thumbs = [...productRoot.querySelectorAll('[data-gallery-thumb]')];
      const updateGallery = () => {
        if (!gallery || !current || !media.length) return;
        const centre = gallery.scrollLeft + gallery.clientWidth / 2;
        let nearest = 0;
        media.forEach((item, index) => {
          const itemCentre = item.offsetLeft + item.offsetWidth / 2;
          if (Math.abs(itemCentre - centre) < Math.abs((media[nearest].offsetLeft + media[nearest].offsetWidth / 2) - centre)) nearest = index;
        });
        current.textContent = String(nearest + 1);
        thumbs.forEach((thumb, index) => {
          if (index === nearest) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      };
      gallery?.addEventListener('scroll', updateGallery, { passive: true });
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
        const target = media[Number(thumb.dataset.galleryThumb)];
        target?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }));
    });
  };
  document.addEventListener('DOMContentLoaded', () => initialiseProduct());
  document.addEventListener('shopify:section:load', (event) => initialiseProduct(event.target));
})();
